import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

// Buton discret back-to-top. Apare după scroll; ascuns când ești deja sus.
// Actualizează starea DOAR când se schimbă (evită re-render la fiecare scroll).
export const BackToTop = () => {
  const [show, setShow] = useState(false);
  const shownRef = useRef(false);
  const tickingRef = useRef(false);

  useEffect(() => {
    const update = () => {
      const next = window.scrollY > 400;
      if (next !== shownRef.current) {
        shownRef.current = next;
        setShow(next);
      }
      tickingRef.current = false;
    };
    const onScroll = () => {
      if (!tickingRef.current) {
        tickingRef.current = true;
        window.requestAnimationFrame(update);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    update();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show ? (
        <motion.button
          type="button"
          data-testid="back-to-top"
          aria-label="Înapoi sus"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          className="fixed bottom-5 right-4 z-40 flex h-12 w-12 items-center justify-center rounded-full bg-roty-red text-white shadow-lg shadow-black/20 transition-colors hover:bg-roty-reddark lg:bottom-8 lg:right-8"
        >
          <ArrowUp className="h-5 w-5" strokeWidth={2.5} />
        </motion.button>
      ) : null}
    </AnimatePresence>
  );
};

export default BackToTop;
